<template>
  <v-container
    id="formResults"
    fluid
    tag="section"
  >
    <base-material-card>
      <template v-slot:heading>
        Submission
        <v-btn
          v-if="!formResult.is_processed"
          class="align-end"
          @click="doMarkProcessed"
        >
          Mark Processed
        </v-btn>

      </template>
      <v-container
        v-if="isSignup"
      >
        <template>
          <v-btn
            v-if="formResult.form_status !== 'account-created'"
            @click="doMapFormToCustomer"
          >
            Map To Customer
          </v-btn>
          <v-dialog
            v-model="dialogMapToCustomer"
            class="pa-3"
            width="600"
            persistent
          >
            <v-card
              class="pa-4"
              v-show="newCustId === 0"
            >
              <v-form>
                <base-material-card
                  class="py-2"
                >
                  <template v-slot:heading>
                    <h2>Customer Details</h2>
                  </template>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="mappedCustomer.customer.name2"
                        label="Customer Name"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="mappedCustomer.customer.phone"
                        label="Phone"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="mappedCustomer.customer.email"
                        label="Email"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="mappedCustomer.customer.address"
                        label="Address"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="mappedCustomer.customer.city"
                        label="City"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="mappedCustomer.customer.state"
                        label="State"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="mappedCustomer.customer.zip"
                        label="Zip"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </base-material-card>
                <base-material-card
                  class="py-2"
                >
                  <template v-slot:heading>
                    <h2>Service Location</h2>
                  </template>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="mappedCustomer.locationService.addr1"
                        label="Address"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="mappedCustomer.locationService.city"
                        label="City"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="mappedCustomer.locationService.state"
                        label="State"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="mappedCustomer.locationService.zip"
                        label="Zip"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </base-material-card>

                <base-material-card
                  class="py-2"
                >
                  <template v-slot:heading>
                    <h2>Billing Location</h2>
                  </template>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="mappedCustomer.locationBilling.addr1"
                        label="Address"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="mappedCustomer.locationBilling.city"
                        label="City"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="mappedCustomer.locationBilling.state"
                        label="State"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="mappedCustomer.locationBilling.zip"
                        label="Zip"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </base-material-card>
                <base-material-card
                  class="py-2"
                >
                  <template v-slot:heading>
                    <h2>Ticket Note</h2>
                  </template>
                  <v-row>

                    <v-col
                      cols="12"
                    >
                      <v-textarea
                        v-model="mappedCustomer.note"
                        label="Note"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </base-material-card>
              </v-form>
              <v-btn
                @click="dialogMapToCustomer = false"
              >
                Close
              </v-btn>
              <v-btn
                :loading="formOverlay"
                :disabled="formOverlay"
                @click="doCreatePlatCustomer"
              >
                Submit Mapped Customer
              </v-btn>
              <v-overlay :value="formOverlay">
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>

            </v-card>
            <v-card
              v-show="newCustId > 0"
            >
              <base-material-card>
                <template v-slot:heading>
                  <h2>Customer Created</h2>
                </template>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    New customer successfully created click <a
                    :href="powURL + '/record.php?id=' + newCustId"
                    target="_blank"
                  >
                    HERE
                  </a>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    If you would like to quick <a
                    :href="powURL + '/edit.php?id=' + newCustId"
                    target="_blank"
                  >
                    EDIT
                  </a>
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="newTktId > 0"
                  >
                    If you would like to quick <a
                    :href="powURL + '/ticket.php?id=' + newTktId"
                    target="_blank"
                  >
                    Ticket
                  </a>
                  </v-col>
                </v-row>
                <v-row>
                  <v-btn
                    @click="dialogMapToCustomer = false"
                  >
                    Close
                  </v-btn>
                </v-row>

              </base-material-card>
            </v-card>
          </v-dialog>
        </template>
      </v-container>

      <pow-raw-form-results
        :submission="formResult"
      >
      </pow-raw-form-results>
      <v-overlay :value="formOverlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>

    </base-material-card>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { FORM_RESULT_GET, FORM_RESULT_GET_MANY, FORM_RESULT_MARK_PROCESSED, FORM_RESULT_CREATE_PLAT_CUST } from '@/store/actions.types'
  import { FORM_RESULT_VWCONFIRM_SIGNUP } from '../../../store/actions.types'

  export default {
    name: 'SubmissionDetails',
    components: {
      PowRawFormResults: () => import('@/components/pow/RawFormResult'),
    },
    data () {
      return {
        selectedAccount: {},
        rowkey: '',
        mappedCustomer: {
          customer: {
            billingmeth: 'email',
            phone: '',
            username: '',
            password: '',
            name2: '',
            address: '',
            address2: '',
            city: '',
            state: 'CA',
            zip: '',
            fax: 'CA',
            email: '',
          },
          locationBilling: {
            addr1: '',
            city: '',
            state: '',
            zip: '',
            lat: '',
            lng: '',
          },
          locationService: {
            addr1: '',
            city: '',
            state: '',
            zip: '',
            lat: '',
            lng: '',
          },
          note: '',
        },
        dialogMapToCustomer: false,
        newCustId: 0,
        newTktId: 0,
        powURL: '',
        formOverlay: false,
      }
    },
    computed: {
      ...mapGetters(['formResult', 'formResults']),
      isSignup: function () {
        try {
          return this.formResult.form.toLowerCase() === 'signup'
        } catch (e) {
          return false
        }
      },
    },
    async created () {
      this.powURL = process.env.VUE_APP_API_POW_URL
      console.log(this.$route)
      if (this.$route.query.rowkey) {
        this.rowkey = this.$route.query.rowkey
        await this.getFormResult(this.$route.query.rowkey)
      }
    },
    mounted () {

      // const queryParams = this.$route.params
    },
    methods: {
      ...mapActions({
        getFormResult: FORM_RESULT_GET,
        getFormResults: FORM_RESULT_GET_MANY,
        updateFormResultProcessed: FORM_RESULT_MARK_PROCESSED,
        postCreatePlatCustomer: FORM_RESULT_CREATE_PLAT_CUST,
        confirmVwSignup: FORM_RESULT_VWCONFIRM_SIGNUP,
      }),
      async doMarkProcessed () {
        this.formOverlay = true
        const payload = {
          rowkey: this.rowkey,
          is_processed: true,
        }
        console.log('Marking processed', payload)
        this.updateFormResultProcessed(payload)
        this.formOverlay = false
      },
      async doMapFormToCustomer () {
        let formResult = {}
        try {
          formResult = JSON.parse(this.formResult.payload)
        } catch (e) {
          formResult = this.formResult.payload
        }
        console.log(formResult)
        const mappedCust = {}
        mappedCust.customer = {
          billingmeth: 'email',
          phone: formResult.accountHolder.mobile_phone ? formResult.accountHolder.mobile_phone : '',
          username: this.formResult.rowkey ? this.formResult.rowkey : '',
          password: this.formResult.id,
          name2: `${formResult.accountHolder.first_name} ${formResult.accountHolder.last_name}`,
          address: formResult.locationService.addr1 ? formResult.locationService.addr1 : '',
          address2: '',
          city: formResult.locationService.city ? formResult.locationService.city : '',
          state: 'CA',
          zip: formResult.locationService.zip ? formResult.locationService.zip : '',
          fax: 'CA',
          email: formResult.accountHolder.email ? formResult.accountHolder.email : '',
        }
        mappedCust.locationService = {
          attn: `${formResult.accountHolder.first_name} ${formResult.accountHolder.last_name}`,
          address_type: 6,
          ...formResult.locationService,
        }
        mappedCust.locationBilling = {
          attn: `${formResult.billingHolder.first_name} ${formResult.billingHolder.last_name}`,
          address_type: 3,
          ...formResult.locationBilling,
        }
        mappedCust.note = `DETAILS:
        Form Key: ${this.formResult.rowkey}
        Plan: ${formResult.servicePlan}
        Description: ${formResult.locationDesc}
        Square Footage: ${formResult.squareFootage}
        Roof Material: ${formResult.roofMaterial}
        Ownership Status: ${formResult.ownershipStatus}
        Install Type: ${formResult.installType}
        Payment Frequency: ${formResult.paymentFrequency} month(s)
        Payment Method: ${formResult.paymentMethod}
        Enroll No Worries: ${formResult.enrollNoWorries}
        Enroll WiFi Upgrade: ${formResult.enrollWifiUpgrade}
        Additional Network Jacks: ${formResult.addNetworkJacksQuantity}
        Email: ${formResult.accountHolder.email} (${formResult.accountHolder.email_verified ? 'Verified' : 'Unverified'})
        Mobile Phone: ${formResult.accountHolder.mobile_phone ? formResult.accountHolder.mobile_phone : ''} (${formResult.accountHolder.mobile_phone_verified ? 'Verified' : 'Unverified'})
        Alternate Phone: ${formResult.accountHolder.alt_phone ? formResult.accountHolder.alt_phone : ''}

        Address: ${formResult.locationService.addr1 ? formResult.locationService.addr1 : ''}, ${formResult.locationService.city ? formResult.locationService.city : ''}, ${formResult.locationService.state ? formResult.locationService.state : ''}, ${formResult.locationService.zip ? formResult.locationService.zip : ''}
        Address Geocode: ${formResult.locationService.lat ? formResult.locationService.lat : ''}, ${formResult.locationService.lng ? formResult.locationService.lng : ''}
        `
        if (formResult.markerDetails && formResult.markerDetails.lat && formResult.markerDetails.lng) {
          mappedCust.note += `
          Marker Details: ${formResult.markerDetails.lat}, ${formResult.markerDetails.lng}
             lat: ${formResult.markerDetails.lat}
             lng: ${formResult.markerDetails.lng}
         `
        }
        console.log(mappedCust)
        this.mappedCustomer = mappedCust
        this.dialogMapToCustomer = true
      },
      async doCreatePlatCustomer () {
        console.log('Rowkey:' + this.rowkey)
        this.formOverlay = true
        try {
          const response = await this.confirmVwSignup({ rowkey: this.rowkey })
          console.log(response)
          if (response.success) {
            this.newCustId = parseInt(response.cust_id)
            if (response.ticket_id && response.ticket_id > 0) {
              this.newTktId = response.ticket_id
            }
          }
          this.formOverlay = false
        } catch (e) {
          this.formOverlay = false
          console.log(e)
        }
        this.formOverlay = false
      },

    },
  }
</script>
